'use strict';

var fetch = require('./fetch/fetch.js');
var fetchJSON = require('./fetch/fetchJSON.js');
var fetchCompositeJSON = require('./fetch/fetchCompositeJSON.js');



exports.default = fetch.bonnetFetch;
exports.fetchJSON = fetchJSON.fetchJSON;
exports.fetchCompositeJSON = fetchCompositeJSON.fetchCompositeJSON;
